import {Api} from '../api';
import {StatusList} from '../status/status_list';
import React from 'react';
import {login} from '../vault_api';
import {LoginForm} from './login_form';
import {request} from '../vault_api';
import {useState} from 'react';


export function LoginController() {
  const [statuses, setStatuses] = useState([]);

  const authenticate = async (username, password) => {
    setStatuses([{message: 'Logging in to the Vault...', type: 'loading'}]);
    let result = null;
    try {
      await login(username, password);
    } catch (error) {
      setStatuses([{message: error.message}]);
      return;
    }
    setStatuses([{message: 'Retreiving Sylvanus token for the vault...', type: 'loading'}]);
    try {
      result = await request('GET', '/v1/identity/oidc/token/sylvanus');
    } catch (error) {
      setStatuses([{message: error.message}]);
      return;
    }
    setStatuses([{message: 'Logging into Sylvanus...', type: 'loading'}]);
    const api = new Api();
    result = await api.request('/login/login.json', null, 'POST', {token: result.data.token});
    if ('errors' in result) {
      setStatuses(result.errors);
    }
    const params = new URLSearchParams(window.location.search);
    if (params.has('destination')) {
      window.location.href = params.get('destination');
    } else {
      window.location.href = '/';
    }
  };

  const onChange = () => {
    setStatuses([]);
  };

  return (
    <React.Fragment>
      <StatusList statuses={statuses} />
      <LoginForm onSubmit={authenticate} onChange={onChange} />
    </React.Fragment>
  );
}
